'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _listeners = require('../../utils/listeners');

var _functional = require('../../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var classes = {
  BTN_LOADING: 'btn-Loading'
};

var selectors = {
  TEXT: '.btn-Text'
};

var Button = exports.Button = function () {
  function Button(el, config) {
    (0, _classCallCheck3.default)(this, Button);

    this.el = el;
    this.els = this.getEls();

    this.config = (0, _assign2.default)({}, config);
    this.loading = this.config.loading || false;
    this.disabled = this.config.disabled || false;

    this.init();
  }

  (0, _createClass3.default)(Button, [{
    key: 'init',
    value: function init() {
      if (this.loading) {
        this.setLoading(true);
      }

      if (this.disabled) {
        this.setDisabled(true);
      }

      this.setupListeners();
    }
  }, {
    key: 'setupListeners',
    value: function setupListeners() {
      this.listeners = new _listeners.Listeners();

      if (this.config.onClick) {
        this.listeners.add(this.el, 'click', this.config.onClick);
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      this.els.text.innerHTML = text;

      return this;
    }
  }, {
    key: 'setDisabled',
    value: function setDisabled(val) {
      this.el.disabled = val;

      return this;
    }
  }, {
    key: 'setLoading',
    value: function setLoading(val) {
      this.loading = val;
      this.el.classList.toggle(classes.BTN_LOADING, val);

      return this;
    }
  }, {
    key: 'getEls',
    value: function getEls() {
      return {
        text: (0, _functional.getElement)(selectors.TEXT, { context: this.el })
      };
    }
  }]);
  return Button;
}();